import api from './api';

const questionnaireService = {
  // Get all responses for a project
  getResponses: async (projectId) => {
    try {
      const response = await api.get(`/questionnaire/projects/${projectId}`);
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch responses';
    }
  },

  // Save responses for all sections
  saveResponses: async (projectId, responses) => {
    try {
      // Need to save each section separately
      const savedResponses = [];
      
      for (const [sectionType, sectionData] of Object.entries(responses)) {
        if (sectionData && Object.keys(sectionData).length > 0) {
          const response = await api.post(
            `/questionnaire/projects/${projectId}/sections/${sectionType}`, 
            sectionData
          );
          
          if (response.data.success) {
            savedResponses.push(...response.data.data);
          }
        }
      }
      
      return savedResponses;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to save responses';
    }
  },

  // Submit questionnaire as completed
  submitQuestionnaire: async (projectId) => {
    try {
      const response = await api.post(`/questionnaire/projects/${projectId}/submit`);
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to submit questionnaire';
    }
  },

  // Generate APD document after questionnaire completion
  generateAPD: async (projectId) => {
    try {
      const response = await api.post(`/questionnaire/projects/${projectId}/generate-apd`);
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to generate APD';
    }
  }
};

export default questionnaireService;